module.exports = __webpack_public_path__ + "static/media/_rituals_app_download_preview_mockup_01@2x.8028c62d.png";